import { defineStore } from "pinia";

export const useTeamStore = defineStore('team', {
    state: () => {
      return {
        teams: [{ value: 0, label: { en: 'all teams' } }]
      }
    },
    persist: true,
});